<template>
    <div class="body">
        <transition appear>
			<div v-if="!reportData" class="zhezhao">
				<div class="image" style="width: 100%; height: 13%">
					<img src="@/assets/logo1.png" style="width: 217px; height: 77px; margin-left: 7px"/>
				</div>

				<div class="right" style="width: 100%; height: 87%">
					<p class="font1" style="font-size: 86px; margin-top: 20vh;color: #fff;text-shadow: #7db133 0px 0px 5px,   #7db133 0px 0px 4px,   #7db133 0px 0px 4px, #7db133 0px 0px 5px,   #7db133 0px 0px 5px,   #7db133 0px 0px 5px;"> 2025富学宝典</p>
					<p class="font1" style=" color: #7db133;font-size: 71px;margin-top: 20px;"> 第一季度学习报告 </p>
					<p class="font1" style="font-size: 41px;margin-top: 27px;color: #fff;text-shadow: #7db133 0px 0px 5px,   #7db133 0px 0px 4px,   #7db133 0px 0px 4px, #7db133 0px 0px 5px,   #7db133 0px 0px 5px,   #7db133 0px 0px 5px;"> 坚持学习的人永葆青春 </p>
				
					<div v-show="!Loading" class="input-container" style="margin-top: 4vh">
					<input v-model="jobNo" type="text" id="input" required="" />
					<label for="input" class="label">请输入工号</label>
					<div class="underline"></div>
					</div>
					<div v-show="!Loading" style="display: flex; justify-content: center;margin-top:40px;">
					<button class="button" @click="inputJobNo()">NEXT</button>
					</div>
					<!-- <LoadingAuguest v-show="Loading" style="margin-top: 30vh" /> -->
				</div>
			</div>
        </transition>
        <main v-if="reportData && reportData.studate != 0" id="main" ref="scrollDiv" class="view">
			<section id="section01" class="section">
				<!-- 有学习天数，有学分 -->
				<div v-if="reportData.studate > 0 && reportData.creditvalue > 0" style="display: flex; flex-wrap: wrap">
					<div class="left" style="width: 100%; margin-top: 10vh">
						<p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
						<p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2025</span>年<span class="font2" style="font-size: 36px;">第一季度</span></p>

						<p class="font1" style="font-size: 30px;margin-top: 15px;">你已经学习了<span class="font2" style="font-size: 32px;">{{ reportData.studate }}</span>天</p>
						<p class="font1"  v-if="reportData.playtime !==null" style="font-size: 30px;margin-top: 15px;">累计学习了<span class="font2" style="font-size: 32px;">{{ reportData.playtime }}</span >小时</p>

						<p class="font1" v-if="reportData.coursenumMon !==null" style="font-size: 30px;margin-top: 15px;">学习了<span class="font2" style="font-size: 32px;">{{ reportData.coursenumMon }}</span >门课程</p>
						<p class="font1" v-if="reportData.coursenum !==null" style="font-size: 36px;text-align: center;margin-top: 45px;">完成了<span class="font2" style="font-size: 32px;">{{ reportData.coursenum }}</span >门课程</p>

						<p class="font1" v-if="reportData.examTimes !==null" style="font-size: 30px;margin-top: 15px;">累计考试<span class="font2" style="font-size: 32px;">{{ reportData.examTimes }}</span >次</p>
						<p class="font1" v-if="reportData.creditvalue !==null" style="font-size: 36px;text-align: center;margin-top: 45px;">获得学分<span class="font2" style="font-size: 32px;">{{ reportData.creditvalue }}</span >分</p>
					</div>
				</div>

				<!-- 有学习天数，没有学分 -->
				<div v-if="reportData.studate > 0 && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
					<div class="left" style="width: 100%; margin-top: 10vh">
						<p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
						<p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2025</span>年<span class="font2" style="font-size: 36px;">第一季度</span></p>

						<p class="font1" style="font-size: 30px;margin-top: 15px;">你在富学宝典平台上的总学习天数达到了<span class="font2" style="font-size: 32px;">{{ reportData.studate }}</span >天</p>
						<p class="font1" style="font-size: 30px;margin-top: 15px;">但是还没有获得学分，请继续加油！</p>
						<p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
					</div>
				</div>

				<!-- 没有学习天数，没有学分 -->
				<div v-if="!reportData.studate && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
					<div class="left" style="width: 100%; margin-top: 20vh">
						<p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
						<p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2025</span>年<span class="font2" style="font-size: 36px;">第一季度</span></p>

						<p class="font1" style="font-size: 30px;margin-top: 15px;">你还没有在富学宝典上学习，请继续加油！</p>
						<p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
					</div>
				</div>
			</section>


			<section id="section02" class="section">
				<div class="page2" style="display: flex; flex-wrap: wrap">
					<div class="right" style="width: 100%; margin-top: 10vh">
						<p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">涉猎知识，智慧渊源，</p>
						<p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">修炼心灵，启迪前程。</p>

						<p  style="text-align: center;font-weight: 700;color: black; font-size: 30px;margin-top: 21px;">2025年富学宝典上热门课程推荐：</p>
						<div v-for="(item,index) in mergeBook.slice(0,3)" :key="index" style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #000;">
							<p @click="redirectToBook(index)" class="font1" style="margin-top: 1vh;">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" style="color:#000;"></i></p>
						</div>

						<p  v-if="uncompletedLink !==null"  style="text-align: center;font-weight: 700;color: #000; font-size: 30px;margin-top: 21px;">以下课程已学习过半，您离完成目标只差一步之遥：</p>
						<div  v-for="(item,index) in mergeBook.slice(3)" :key="index+3" style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #000;">
							<p @click="redirectToBook(index+3)" class="font1" style="margin-top: 1vh;">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" style="color:#000;"></i></p>
						</div>
					</div>
				</div>
			</section>

			<section id="section03" class="section">
				<div style="display: flex; flex-wrap: wrap">
					<div class="right" style="width: 100%; margin-top: 10vh">
						<p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">勤耕岁月学无涯，</p>
						<p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">积学成才道路赊。</p>
						<div>
							<p class="font1" style="margin: 0 auto; font-size: 30px;color: #000;text-align: center;margin-top: 3vh;">EHS+ESG 第一季度主题课程推荐：</p>
							<ul style="margin: 0 auto; font-size: 30px;color: #fff;;text-align: center;margin-top: 3vh;">
								<a href="https://iedu.foxconn.com/public/play/play?courseId=53951&companyId=728" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">解读碳中和-工程处25年3月专业课 </li></a>
								<a href="https://iedu.foxconn.com/public/play/play?courseId=49852&companyId=727" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">专题培训 ISO14064-3碳足迹核查</li></a>
								<a href="https://iedu.foxconn.com/public/play/play?courseId=48653&companyId=813" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">2024年认识生物多样性保护生物多样性专题知识培训</li></a>
								<a href="https://iedu.foxconn.com/public/play/play?courseId=48183&companyId=727" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">专题培训 CBAM欧洲碳边境机制</li></a>
								<a href="https://iedu.foxconn.com/public/play/play?courseId=44624&companyId=727" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">Topic-Specific Training Carbon Footprinting (Scope 1, 2 & 3) and Science-based Targets </li></a>
								<a href="https://iedu.foxconn.com/public/play/play?courseId=43057&companyId=727" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">Carbon Footprinting</li></a>
							</ul>
						</div>
						<div style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #000;" v-if="coc">
							<p class="font1" style="margin: 0 auto; font-size: 30px;color: #000;text-align: center;margin-top: 2vh;">必修课程完成情况：</p>
							<ul v-for="(item,index) in coc" :key="index" ref="">
								<a :href="item.link" style="text-decoration: none;color: #000;">
									<li style="padding: 0;margin-top: 0;">{{ item.Name }}&nbsp;
										<span v-if="item.iscompleted" style="color: #e06c24;font-weight: 800;">已完成</span>
										<span v-else style="color: red;font-weight: 800;">未完成</span>
									</li>
								</a>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="section04" class="section">
				<div class="page4"  style="display: flex; flex-wrap: wrap">
					<div class="title"><p class="font1" style="font-size: 60px;">好书推荐</p></div>
					<div class="left" style="margin-top: 40px;width: 80%;margin: 0 auto;">
						<div class="detail">
							<p style="text-align: center;font-size: 30px;color: black;">《用数字讲故事》</p>
							<p class="font2" style="font-size: 18px;text-align: center;"> [美]奇普·希思，[美]卡拉·斯塔尔</p>
						</div>
						<div class="bookDetail" style="font-size: 17px;padding: 20px;color: #000;">
							<span style="font-size: 20px;">
								本书通过心理学和行为科学的研究，提出了一系列“数字转化”技巧，包括使用类比、情镜化描述、转化单位、视觉化呈现等，让统计数据变成鲜活的故事。<br><br>
								本书提出了四大有效使用数字的原则，列举了80多个数字转换的案例，横跨商业、医疗、科学等领域。<br><br>  
								对于那些对原始数字和统计数据感动困惑、希望借助数字做决策的人，这本书提供了实用的指导。在这个数据驱动的世界里，掌握讲述数字故事的能力，将成为一种不可或缺的竞争力！<br><br> 
							</span>
						</div>
					</div>
					<div class="right" style="margin-top: 40px;width: 80%;margin: 0 auto;">
						<div class="detail">
							<p style="text-align: center;font-size: 30px;color: black;">《倾听的力量》</p>
							<p class="font2" style="font-size: 18px;text-align: center;">  [美] 马克·郭士顿</p>	
						</div>
						<div class="bookDetail" style="font-size: 17px;padding: 20px;">
							<span style="font-size: 20px;text-align: justify;color:#000;">
								沟通不是自说自话，是要说到对方的心里，更是要持续改变对方的行为。做到这一切的前提是倾听。本书作者是美国著名的心理医生和商务沟通教练，从事商务沟通培训超过30年，本书将其长期以来的临床经验和培训经验相结合，用中肯的文风和大量真实案例说透了沟通的关键——倾听。<br><br>
								他将这些奥秘凝练成9条核心法则，12个快捷沟通工具，7类棘手问题解决方案，方便读者在各种日常和工作场景中综合运用。读完本书你会发现，只要有方法可依，沟通并不困难，而且一次得当的倾听或许会给你带来持久的高质量关系。<br><br>
							</span>
						</div>
					</div>         
				</div>
			</section>

			<section id="section05" class="section">
				<div class="page5" style="position: relative;top: 10vh;">
					<div class="flag-selector">
						<div class="header">
							<!-- <h1>下月学习Flag选择</h1> -->
							<P class="font1">逐梦前行，点亮成长</P>
							<P class="font1">开启你的季度学习FLAG！</P>
							<!-- <P class="font1">让我们坚定信念，勇敢追梦！</P> -->
						</div>
						
						<div class="goals-container">
							<div class="goal-row" v-for="(row, rowIndex) in goalRows" :key="rowIndex">
							<div class="goal-wrapper" :style="getAnimationStyle(rowIndex)">
								<div class="goal" v-for="(goal, index) in row.goals" :key="`${rowIndex}-${index}`" :data-id="goal.id" :class="{ selected: isSelected(goal.id) }" @click="toggleGoal(goal.id)">
								<div class="goal-icon">{{ goal.emoji }}</div>
								<div class="goal-text">{{ goal.text }}</div>
								<div class="check-icon">✓</div>
								</div>
								<!-- 复制元素以实现无缝滚动 -->
								<div class="goal" v-for="(goal, index) in row.goals" :key="`${rowIndex}-${index}-copy`" :data-id="goal.id" :class="{ selected: isSelected(goal.id) }" @click="toggleGoal(goal.id)">
								<div class="goal-icon">{{ goal.emoji }}</div>
								<div class="goal-text">{{ goal.text }}</div>
								<div class="check-icon">✓</div>
								</div>
							</div>
							</div>
						</div>
						
						<div class="footer">
							<button class="confirm-btn" :disabled="selectedGoals.length === 0" @click="confirmSelection">确认选择</button>
						</div>
					</div>
				</div>
			</section>
        </main>
    </div>
</template>

<script>
import Loading from './Loading.vue'
import viewApi from "@/api/view";
import dataApi from "@/api/data";
import { getArray } from "../../utils/encourage";
export default {
    data(){
		return{
			viewId: "",
			Loading:false,
			reportData:'',
			jobNo:'',
			// comment: "",
			source: "",
			coc:'',

			recommendBook:'',
			uncompletedLink:'',
			mergeBook:'',
			themeLink:'',
			selectedGoals: [],
			goalRows: [
				{
					goals: [
						{ id: '1', emoji: '⏳', text: '时间掌控在手，高效人生由你决定！' },
						{ id: '2', emoji: '🎯', text: '设定清晰目标，一步步迈向成功！' },
						{ id: '3', emoji: '💻', text: '玩转办公软件，让效率飞跃提升！' },
						{ id: '4', emoji: '📊', text: '用数据说话，让分析更有洞察力！' }
					]
				},
				{
					goals: [	
						{ id: '5', emoji: '🤝', text: '掌握谈判技巧，赢得更多职场优势！' },
						{ id: '6', emoji: '🌍', text: '拓展全球视野，让沟通无国界！' },
						{ id: '7', emoji: '📊', text: '数据驱动决策，掌握未来核心竞争力！' },
						{ id: '8', emoji: '🏭', text: '工业智能化，引领制造新趋势！' },
					]
				},
				{
					goals: [	
						{ id: '9', emoji: '💙', text: '释放压力，保持心理韧性！' },
						{ id: '10', emoji: '🚑', text: '关键时刻，学会自救，守护生命！' },
						{ id: '11', emoji: '🔋', text: '低碳生活，共建可持续未来！' }
					]
				},
				{
					goals: [	
						{ id: '12', emoji: '🌏', text: '跟上时代步伐，拥抱绿色未来！' },
						{ id: '13', emoji: '📜', text: '合规经营，企业可持续发展！' },
						{ id: '14', emoji: '🧑‍💻', text: '尊重创造，保护创新成果！' }
					]
				}
			]
		}
    },
    created(){
		document.title = "第一季度学习报告";
		/* 相信数据begin */
		var test = window.location.href
		let arr = test.split("?code=")
		this.code = arr[1]
		if (this.code) {
			viewApi.getJobNoByBelieve(this.code).then((res) => {
			if(res.data.code === 200) {
				this.jobNo = res.data.data.jobNo
				this.source = "相信"
				if (this.jobNo) {
					this.Loading = true;
					this.getData()
				}
			}
			})
		}
		/* 相信数据end */
    },
    methods:{
		inputJobNo() {
			if (this.Loading === true) {
				return;
			}
			if (this.jobNo) {
				this.Loading = true;
				this.getData();
			} else {
				this.$message({
					message: "请输入工号",
					type: "warning",
					center: true,
				});
			}
		},
		getData() {
			dataApi.getDataFor25March(this.jobNo).then((res) => {
				this.reportData = res.data.data.data;
				// console.log(res.data.data.data);

				this.recommendBook=JSON.parse(this.reportData.topRecommendLink)
				this.uncompletedLink=JSON.parse(this.reportData.uncompletedLink)
				this.mergeBook=this.recommendBook.concat(this.uncompletedLink)
				this.coc=JSON.parse(this.reportData.coc)
				// this.themeLink=JSON.parse(this.reportData.themeLink)

				if (this.reportData) {
					this.sendViewRecords();
					// this.Loading = false;
					this.reportData.textLab = getArray(this.reportData.textLab);
				} else if (!this.reportData) {
					this.$message({
						message: "抱歉，暂时找不到您的学习报告！",
						type: "warning",
						center: true,
					});
					this.Loading = false;
				}
			});
		},
		sendViewRecords() {
			if (this.jobNo) {
				let viewData = {
					jobNo: this.jobNo,
					device: "PC",
					type: 29,
					browser: this.browser,
				};
				if (this.source) {
					viewData["source"] = this.source;
				}
				viewApi.view(viewData).then((res) => {
					this.viewId = res.data.data.data.id;
				});
			} else {
				return;
			}
		},
		redirectToBook(id){
			const book=this.mergeBook[id]
			const view={
				clickCourseName:book.Name,
				clickCourseLink:book.link
			}
			view["id"] = this.viewId;
			viewApi.update(view).then((res) => {
				if (res.data.code===200) {
					window.location.href = view.clickCourseLink;
				}
			});
		},
		toggleGoal(goalId) {
			const index = this.selectedGoals.indexOf(goalId);
			
			if (index === -1 && this.selectedGoals.length < 3) {
				this.selectedGoals.push(goalId);
			} else if (index !== -1) {
				this.selectedGoals.splice(index, 1);
			} else {
				alert('最多可选3个目标哦！');
			}
		},
        isSelected(goalId) {
            return this.selectedGoals.includes(goalId);
        },
        confirmSelection() {			
			if (this.selectedGoals.length === 0) {
				this.$message({
					message: "请选择至少一个目标!",
					type: "warning",
					center: true,
				});
			} else  {
				 // 获取选择的目标文本
				 const selectedGoalTexts = this.selectedGoals.map(goalId => {
                for (const row of this.goalRows) {
                    const foundGoal = row.goals.find(goal => goal.id === goalId);
                    if (foundGoal) return foundGoal.text;
                }
                return null;
            }).filter(text => text !== null); // 过滤掉 null，确保数据干净

				const view = {
					comment: selectedGoalTexts.join(', '),
					// studyList: this.studyList,
				};
				view["id"] = this.viewId;
				// console.log(view);
				viewApi.update(view).then((res) => {
					if (res) {
						this.$message({
							message: "提交成功",
							type: "success",
							center: true,
						});
					}
				});
			}
        },
        getAnimationStyle(rowIndex) {
            // 为每行设置不同的动画延迟
            const delay = rowIndex * 1000;
            return {
                animationDelay: `${delay}ms`
            };
        }
    },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
/* 字体样式 */
.font1{
  color: black; 
  font-family: Helvetica, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
  text-align: center;
}
.font2{
  color: #7db133; 
  font-family: Helvetica, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
}

.font3{
  color: #7db133; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  text-align: center;
}
/* 第一页 */
.body {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}

.zhezhao {
  width: 100vw;
  height: 100vh;
  /* background-image: linear-gradient(170deg, #b55d7f , #953b5d); */
  background:url("../../assets/25March/pcbg.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  position: absolute;
  display: flex;
  flex-wrap: wrap;
}
.input-container {
  position: relative;
  margin: 50px auto;
  width: 400px;
}

.input-container input[type="text"] {
  font-size: 20px;
  width: 100%;
  border: none;
  border-bottom: 2px solid #ccc;
  padding: 5px 0;
  background-color: transparent;
  outline: none;
  color: #fcc741;
}

.input-container .label {
  position: absolute;
  top: 0;
  left: 0;
  color: #ccc;
  transition: all 0.3s ease;
  pointer-events: none;
}

.input-container input[type="text"]:focus ~ .label,
.input-container input[type="text"]:valid ~ .label {
  top: -20px;
  font-size: 16px;
  color: #7db133;
}

.input-container .underline {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: #7db133;
  transform: scaleX(0);
  transition: all 0.3s ease;
}

.input-container input[type="text"]:focus ~ .underline,
.input-container input[type="text"]:valid ~ .underline {
  transform: scaleX(1);
}
.button {
  --bg: #7db133;
  --text-color: #fff;
  position: relative;
  width: 150px;
  height: 40px;
  border: none;
  background: var(--bg);
  color: var(--text-color);
  padding: 1em;
  font-weight: bold;
  text-transform: uppercase;
  transition: 0.2s;
  border-radius: 5px;
  opacity: 0.8;
  letter-spacing: 1px;
  box-shadow: #9e9ed6 0px 7px 2px, #000 0px 8px 5px;
}

.button:hover {
  opacity: 1;
}

.button:active {
  top: 4px;
  box-shadow: #6e2441 0px 3px 2px, #000 0px 3px 5px;
}

/* 第二页 */
.view {
  width: 100%;
  height: 100%;
  background:url("../../assets/25March/pcbg.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  /* background-image: linear-gradient(170deg, #7a94ac , #a2bed8); */
}
main {
  scroll-snap-type: y mandatory;
  scroll-padding: 80px;
  overflow: scroll;
  height: 100vh;
}
section {
  width: 100vw;
  height: 100vh;
  scroll-snap-align: start;
}
#section01,#section02,#section03,#section04{
  position: relative;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #fff;
    text-align: center;
}
li {
    align-items: center;
    margin-bottom: 8px; 
}

/*书籍推荐页 */
.title {
  font-size: 50px;
  width: 100%;
  margin-bottom: 30px;
  margin-top: 30px;
}

.flag-selector {
    /* background: 
                url("../../assets/25March/logo.png") right  top  no-repeat,
                url("../../assets/25March/bg.jpg")  no-repeat;
    background-size: 100% 100%,cover; */
    width: 100%;
    height: 100vh;
    padding-top: 20px;
}
  
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
}
  
.header {
    text-align: center;
    margin-top: 10vh;
    margin-bottom: 2vh;
}

.header p {
    width: 96%;
    margin: 0 auto;
    font-size: 20px;
    text-align: center·;
    color: #64892f;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.header h1 {
    font-size: 19px;
    color: #333;
}

.goals-container {
    max-width: 780px;
    margin: 0 auto;
}

.goal-row {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    overflow: hidden;
    position: relative;
    height: 40px;
}

.goal-wrapper {
    display: flex;
    animation: scrollGoals 30s linear infinite;
    animation-fill-mode: forwards;; 
}

.goal {
    background-color: #fff;
    border-radius: 20px;
    padding: 8px 15px;
    margin: 0 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    transition: all 0.2s;
    /* min-width: 120px; */
}
  
.goal:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}
  
.goal.selected {
    background-color: #e6f7ff;
    color: #1890ff;
}
  
.goal-icon {
    margin-right: 8px;
    font-size: 19px;
}

.goal-text {
    flex: 1;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
  
.check-icon {
    display: none;
    margin-left: 8px;
    font-size: 16px;
}

.goal.selected .check-icon {
    display: block;
}
  
.footer {
    text-align: center;
    margin-top: 20px;
}
  
.confirm-btn {
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 20px;
    padding: 10px 25px;
    font-size: 16px;
    cursor: pointer;
}
  
.confirm-btn:disabled {
    background-color: #bbb;
    cursor: not-allowed;
}
  
@keyframes scrollGoals {
    0% {
        transform: translateX(50%);
    }
    100% {
        transform: translateX(-50%);
    }
}
/* 

*/
</style>